/* src/app/components/pages/home/home.component.scss */
.slideshow {
  width: 100%;
  cursor: grab;
}
.slideshow video {
  width: 100%;
  height: 75vh;
  object-fit: cover;
  position: relative;
  z-index: 0;
}
.slideshow .video-container {
  position: relative;
}
.slideshow .content {
  position: absolute;
  top: 35%;
  left: 3%;
  z-index: 1;
}
.home-1-wrap {
  background-color: white !important;
  font-family: "IBM Plex Sans", sans-serif !important;
}
.shop-btn {
  background: var(--theme-deafult-secondary);
  border-radius: 23px;
  display: inline-block;
  padding: 15px 32px;
  cursor: pointer;
}
.shop-btn:hover {
  background-color: var(--theme-deafult-secondary);
}
.vh-90 {
  height: 100vh;
}
.img-bg {
  flex: none !important;
  background-size: cover;
  object-fit: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 560px;
}
.img-bg2 {
  flex: none !important;
  background-size: cover;
  object-fit: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.h-661 {
  height: 661px !important;
}
.light-block {
  background-color: rgba(0, 0, 0, 0.41) !important;
  width: 100% !important;
  height: 100% !important;
  place-content: center !important;
}
.d-none {
  opacity: 0;
}
.faded-in {
  animation: fadeIn 0.6s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(16px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
.faded-out {
  animation: fadeOut 0.6s;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    transform: translateY(16px);
  }
}
.productIn {
  animation: productIn 0.6s;
}
@keyframes productIn {
  0% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
.product-button {
  margin: 20px;
  padding: 6px 32px !important;
  background-color: var(--theme-deafult-secondary) !important;
  color: white !important;
}
.product-button:hover {
  background-color: var(--theme-deafult-secondary) !important;
}
.sale {
  padding: 10px 17px;
  background-color: #CF2929;
  border-radius: 23px;
  display: inline;
  color: white;
}
.text-end {
  text-align: end;
}
.bg-white-smoke {
  background-color: rgb(240, 240, 240);
}
.vl {
  border-left: 1px solid #dddddd;
  height: 200px;
}
.img-hover {
  overflow: hidden;
}
.img-hover img {
  transition: 0.5s all ease-in-out;
  cursor: pointer;
}
.img-hover:hover img {
  transform: scale(1.1);
}
.bg-img img {
  width: 100%;
  height: 570px;
  object-fit: cover;
  object-position: bottom;
}
.p-relative {
  position: relative !important;
}
.p-absolute {
  position: absolute !important;
}
.p-abs {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
}
.p-content-div {
  top: 30%;
  left: 3%;
}
.w-35 {
  width: 35%;
}
.abs-width {
  width: 100%;
  left: 5%;
}
.w-89 {
  width: 89%;
}
.slider-img {
  width: 100% !important;
  object-fit: cover !important;
  object-position: top !important;
}
.top-left {
  top: 5%;
  left: 3%;
}
.top-0 {
  top: 0;
}
.p-fixed {
  bottom: 4%;
  position: fixed;
}
.is-visible {
  display: block;
}
.is-open {
  transform: translateY(0px);
  opacity: 1;
}
@media (min-width: 0px) and (max-width: 960px) {
  .img-bg {
    height: 320px !important;
  }
}
.a-hover {
  text-decoration: underline;
}
.a-hover:hover {
  opacity: 0.6;
}
@media (min-width: 0px) and (max-width: 960px) {
  .img-bg {
    height: 320px !important;
  }
  .d-none {
    opacity: 1 !important;
  }
}
/*# sourceMappingURL=home.component.css.map */
